export default __webpack_public_path__ + "static/media/schemat1.c5887c31.png";